(function () {
  // Sofort das Metafield-Color-Hex auslesen
  var customVariantColorElement = document.getElementById("custom-variant-color-hex");
  var colorHex = customVariantColorElement
    ? customVariantColorElement.getAttribute("data-color-hex")
    : null;

  if (!colorHex) {
    console.warn("data-color-hex attribute not found on #custom-variant-color-hex element.");
    return;
  }

  // Normalisieren (Großbuchstaben)
  colorHex = colorHex.toUpperCase();
  var isWhite = colorHex === "#FFFFFF";

  // Helligkeit ein Mal berechnen
  var getBrightness = function (hex) {
    var rgb = hex
      .replace("#", "")
      .match(/.{2}/g)
      .map(function (x) {
        return parseInt(x, 16);
      });

    return (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000; // Weighted formula
  };

  var brightness = getBrightness(colorHex);

  /**
   * ANNOUNCEMENT BAR STYLING
   */
  var announcementBarWrapper = document.querySelector(".shopify-section--announcement-bar");
  var announcementBarIcons = document.querySelectorAll(".shopify-section--announcement-bar .tap-area");
  var announcementBar = document.querySelector(".announcement-bar");
  var header = document.querySelector(".header");

  if (announcementBar) {
    // Hintergrundfarbe der Bar
    announcementBar.style.setProperty("background-color", colorHex, "important");

    // Icons einfärben
    announcementBarIcons.forEach(function (icon) {
      icon.style.color = colorHex;
    });

    // Textfarbe in der Bar nach Helligkeit
    if (brightness > 186) {
      // Heller Hintergrund
      announcementBar.style.setProperty("color", "#000", "important");
    } else {
      // Dunkler Hintergrund
      announcementBar.style.setProperty("color", "#FFF", "important");
    }

    // Spezielle Behandlung für Weiß
    if (isWhite) {
      if (announcementBarWrapper) {
        announcementBarWrapper.style.removeProperty("margin-bottom");
      }
      announcementBar.style.removeProperty("border-bottom");
      if (header) {
        header.style.setProperty("border-top", "1px solid #dcdcdc", "important");
      }
    } else {
      announcementBar.style.removeProperty("border-bottom");
      if (header) {
        header.style.removeProperty("border-top");
      }
    }
  }

  /**
   * ADD TO CART BUTTON STYLING (zentrale Funktion)
   */
  var styleAddToCartButton = function (button) {
    if (!button) return;

    var buttonText = button.querySelector(".loader-button__text");
    if (!buttonText) return;

    // Hintergrund immer in Variant-Color
    button.style.setProperty("background-color", colorHex, "important");

    // Weiß → immer schwarze Schrift + schwarze Border
    if (isWhite) {
      buttonText.style.setProperty("color", "#000", "important");
      button.style.setProperty("border", "1px solid #000", "important");
      return;
    }

    // Normale Logik über Helligkeit
    if (brightness > 186) {
      // Heller Hintergrund → schwarze Schrift
      buttonText.style.setProperty("color", "#000", "important");
      button.style.removeProperty("border");
    } else {
      // Dunkler Hintergrund → weiße Schrift
      buttonText.style.setProperty("color", "#FFF", "important");
      button.style.removeProperty("border");
    }
  };

  // Initial vorhandenen Add-to-Cart-Button stylen
  styleAddToCartButton(document.querySelector("button#AddToCart"));

  /**
   * SWATCHES STYLING
   */
  var updateSwatchBackground = function () {
    var swatchItems = document.querySelectorAll(".block-swatch__item");
    swatchItems.forEach(function (item) {
      var radio = item.previousElementSibling;
      if (radio && radio.checked) {
        item.style.setProperty("background-color", colorHex, "important");

        // Textfarbe auf Basis der Helligkeit
        if (brightness > 186) {
          item.style.setProperty("color", "#000", "important");
        } else {
          item.style.setProperty("color", "#FFF", "important");
        }
      } else {
        item.style.removeProperty("background-color");
        item.style.removeProperty("color");
      }
    });
  };

  // Initiale Swatch-Färbung
  updateSwatchBackground();

  // Beobachte DOM-Änderungen (z. B. wenn Swatches nachgeladen werden)
  var swatchObserver = new MutationObserver(function () {
    updateSwatchBackground();
    styleAddToCartButton(document.querySelector("button#AddToCart"));
  });

  swatchObserver.observe(document.body, { childList: true, subtree: true });

  // Auf Change-Events der Radios hören
  document.addEventListener("change", function (event) {
    if (event.target.matches(".block-swatch__radio")) {
      updateSwatchBackground();
      styleAddToCartButton(document.querySelector("button#AddToCart"));
    }
  });

  /**
   * MutationObserver speziell für AddToCart (falls Button neu gerendert wird)
   */
  var addToCartObserver = new MutationObserver(function () {
    styleAddToCartButton(document.querySelector("button#AddToCart"));
  });

  addToCartObserver.observe(document.body, { childList: true, subtree: true });
})();
